module.exports = __webpack_public_path__ + "static/media/43pic.b3fdc821.jpg";